module.exports = __webpack_public_path__ + "media/images/ADC_favicon-1542b6b96ebeec9e504408f722d0b964.svg";